import { z } from 'zod';

import { CoverSourceName, MediaSourceValue } from './asset-source';
import { Translation } from './translation';

export const CreateExerciseDto = z.object({
  mediaType: z.string(),
  mediaSource: MediaSourceValue,
  coverSource: CoverSourceName,
  coverType: z.string().optional(),
  allowAutoCoverExtract: z.boolean().optional(),
  level: z
    .number()
    .min(0, 'VALIDATION__NonNegative')
    .max(5, 'VALIDATION__MaxValue5'),
  tags: z.array(z.string()).optional(),
  translations: z.array(Translation),
  configuration: z
    .object({
      organizationIds: z.array(z.string()).optional(),
      marketplace: z
        .object({
          enabled: z.boolean(),
          price: z.number().nonnegative().optional(),
          currency: z.string().optional(),
        })
        .optional(),
      isOrg: z.boolean().optional(),
    })
    .optional(),
  // "Copy template" builds the copy in the browser, so the create request is
  // the only place the server learns the source: a copy of purchased content
  // is recorded as purchase-derived (never a column of the new row).
  copiedFromExerciseId: z.string().uuid().optional(),
});

export type ApiCreateExerciseDto = z.infer<typeof CreateExerciseDto>;

export const UpdateExerciseDto = z
  .object({
    mediaType: z.string().optional(),
    mediaSource: MediaSourceValue.optional(),
    coverSource: CoverSourceName.optional().nullable(),
    coverType: z.string().optional().nullable(),
    allowAutoCoverExtract: z.boolean().optional(),
    level: z
      .number()
      .min(0, 'VALIDATION__NonNegative')
      .max(5, 'VALIDATION__MaxValue5'),
    tags: z.array(z.string()).optional(),
    translations: z.array(Translation).optional(),
    configuration: z
      .object({
        organizationIds: z.array(z.string()).optional(),
        marketplace: z
          .object({
            enabled: z.boolean(),
            price: z.number().nonnegative().optional(),
            currency: z.string().optional(),
          })
          .optional(),
        isOrg: z.boolean().optional(),
      })
      .optional(),
  })
  .strict();

export type ApiUpdateExerciseDto = z.infer<typeof UpdateExerciseDto>;

export const UpdateMarketplaceConfigDto = z.object({
  configuration: z.object({
    marketplace: z.object({
      enabled: z.boolean(),
      price: z.number().nonnegative().optional(),
      currency: z.string().optional(),
    }),
  }),
});

export type ApiUpdateMarketplaceConfigDto = z.infer<
  typeof UpdateMarketplaceConfigDto
>;
